import React from 'react';
import styles from './About.module.css';

const About: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.title}>Qui sommes-nous ?</h2>
        <p className={styles.subtitle}>
          Deux experts en retail, e-commerce et nouvelles technologies. Un gars, une fille, animés par les tendances de l'écosystème, en France et à l'international.
        </p>

        <div className={styles.personBlock}>
          <div className={styles.imageWrapper}>
            <div className={styles.imageContainer}>
              <img
                src="/assets/images/laetitia.png"
                alt="Laetitia Lamari"
                className={styles.personImage}
              />
            </div>
            <div className={styles.personName}>Laetitia LAMARI</div>
          </div>
          <div className={styles.bio}>
            Laetitia est une spécialiste accomplie en marketing dans le secteur du commerce, avec 15 ans d'expérience couvrant diverses facettes de cette industrie dynamique. Elle a contribué à façonner les stratégies marketing pour des entreprises allant des startups aux multinationales. Passionnée par l'innovation et l'impact social du commerce, Laetitia est également une conférencière appréciée et une référence en marketing. Co-créatrice de « Le Café De l'Ecommerce », elle joue un rôle vital en mettant en lumière les dernières tendances et opportunités dans le monde du commerce électronique.
          </div>
        </div>

        <div className={styles.personBlock}>
          <div className={styles.imageWrapper}>
            <div className={styles.imageContainer}>
              <img
                src="/assets/images/adrien.jpg"
                alt="Adrien Naeem"
                className={styles.personImage}
              />
            </div>
            <div className={styles.personName}>Adrien NAEEM</div>
          </div>
          <div className={styles.bio}>
            Adrien est un expert en commerce électronique qui a joué un rôle clé dans le lancement de Salesforce Commerce Cloud en France en 2010. Avec 15 ans d'expérience dans des entreprises SaaS américaines, il est également un conférencier reconnu, un influenceur notable sur LinkedIn, et s'investit en tant que bénévole pour l'inclusion numérique. En outre, il est cofondateur de « Le Café De l'Ecommerce », le premier média indépendant dans le domaine de l'e-commerce.
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
